import { getBySceneCode } from '@/api/aigc/index'
const ai = {
  namespaced: true,
  state: {
    showAi: false,
    isScene: undefined,
    isAICenter: false,
    aiShowType: 0,
    chatValue: '', // 聊天框的值
    ifClose: false // 是否手动点击关闭Ai助手的图标显示
  },
  getters: {
    isScene(state) {
      return state.isScene
    },
    aiShowType(state) {
      return state.aiShowType
    },
    isAICenter(state) {
      return state.isAICenter
    },
    ifClose(state) {
      return state.ifClose
    }
  },
  mutations: {
    SET_SCENE: (state, data) => {
      state.isScene = data
    },
    SET_CHATVALUE: (state, data) => {
      state.chatValue = data
    },
    SET_AISHOWTYPE: (state, data) => {
      state.aiShowType = data
    },
    SET_ATCENTER: (state, data) => {
      state.isAICenter = data
    },
    SET_IFCLOSE: (state, data) => {
      state.ifClose = data
    },
    SET_SHOWAI: state => {
      state.showAi = !state.showAi
    }
  },
  actions: {
    async setScene({ commit }, data) {
      commit('SET_SCENE', data)
    },

    async aiOpen({ commit }, data) {
      commit('SET_AISHOWTYPE', 1)
      commit('SET_CHATVALUE', data.text)
      const res = await getBySceneCode({ sceneCode: data.key })
      if (res.code !== 1) return
      if (res.data) {
        commit('SET_SCENE', {
          ...res.data,
          id: res.data.templateId
        })
        commit('SET_SHOWAI')
      }
    },
    async setChatValue({ commit }, data) {
      commit('SET_CHATVALUE', data)
    },
    async setAiShowType({ commit }, data) {
      commit('SET_AISHOWTYPE', data)
    },
    async setAICenter({ commit }, data) {
      commit('SET_ATCENTER', data)
    }
  }
}
export default ai
